import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Route } from 'app/routing/routesConfig';
import { DataTestId } from 'types/general.types';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbProps,
  Icon,
  Text,
} from '@chakra-ui/react';
import { ReactComponent as ChevronIcon } from 'resources/images/chevron-right.svg';

interface BreadcrumbsProps extends BreadcrumbProps {
  routes: Array<Route & DataTestId>;
}

export const ChakraBreadcrumbs: React.FC<BreadcrumbsProps> = ({
  routes,
  ...rest
}) => {
  const { pathname } = useLocation();

  let activeRoutePosition = 0;

  routes.forEach(({ path }, index) => {
    if (pathname.includes(path)) {
      activeRoutePosition = index;
    }
  });

  const activeRoutes = routes.slice(0, activeRoutePosition + 1);

  return (
    <Breadcrumb
      spacing="4px"
      separator={
        <Icon as={ChevronIcon} width={3} height={3} color="iconBase" />
      }
      sx={{
        '.chakra-breadcrumb__list': {
          flexWrap: 'wrap',
        },
      }}
      {...rest}
    >
      {activeRoutes.map(({ path, name, 'data-testid': dataTestId }, index) => (
        <BreadcrumbItem
          key={path}
          isCurrentPage={index === activeRoutePosition}
        >
          {index === activeRoutePosition ? (
            <Text
              lineHeight="17px"
              role="link"
              data-testid={`${dataTestId || name}-breadcrumb`}
              fontWeight={500}
              userSelect="none"
            >
              {name}
            </Text>
          ) : (
            <BreadcrumbLink
              as={RouterLink}
              color="textSubdued"
              to={path}
              data-testid={`${dataTestId || name}-breadcrumb`}
              aria-label={name}
            >
              {name}
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
};
